<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="statsAttendance"
      :loading="loading"
      item-key="id"
      loading-text="Đang Tải"
      mobile-breakpoint="0"
      disable-sort
      no-data-text="Không có dữ liệu"
      :footer-props="{
        'items-per-page-text': 'Số dòng mỗi trang'
      }"
    >
      <!-- Học viên -->
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <!-- Lớp -->
      <template v-slot:[`item.class`]="{ item }">
        {{ item.class.title || '' }}
      </template>
      <!-- Số buổi vắng -->
      <template v-slot:[`item.absent`]="{ item }">
        {{ item.absent }}
      </template>
      <!-- Số buổi có mặt -->
      <template v-slot:[`item.attended`]="{ item }">
        {{ item.attended }}
      </template>
      <template v-slot:[`item.rate`]="{ item }"> {{ item.attended }} / {{ item.total }} ({{ item.rate.toFixed(2) }}%) </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn class="elevation-0" icon @click="() => openDialog(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <DiligenceDetailDialog ref="diligence-detail-dialog"></DiligenceDetailDialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DiligenceDetailDialog from '@/views/diligence/components/DiligenceDetailDialog.vue'

const defaultHeaders = [
  {
    text: 'Học viên',
    value: 'student',
    align: 'left',
    sortable: true,
    show: true,
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'center',
    sortable: false,
    show: true,
  },
  {
    text: 'Số buổi vắng',
    value: 'absent',
    align: 'center',
    sortable: false,
    show: true,
  },
  {
    text: 'Số buổi có mặt',
    value: 'attended',
    align: 'center',
    sortable: false,
    show: true,
  },
  {
    text: 'Tỉ lệ',
    value: 'rate',
    align: 'center',
    sortable: false,
    show: true,
  },
  { text: 'Thao tác', value: 'action', width: 100, sortable: false, align: 'center' },
]
export default {
  data() {
    return {
      headers: defaultHeaders,
    }
  },
  components: {
    CardStudentName,
    DiligenceDetailDialog,
  },
  computed: {
    ...mapState('lessonAttendance', ['statsAttendance', 'loading']),
  },
  created() {
    this.setStatsAttendance([])
  },
  methods: {
    ...mapMutations({
      setStatsAttendance: 'lessonAttendance/setStatsAttendance',
    }),
    openDialog(items) {
      this.$refs['diligence-detail-dialog'].openDialog(items)
    },
  },
  watch: {},
}
</script>
